import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetPolicyParams } from "apis/data-contracts";

export const useSignUpTerms = (params: GetPolicyParams) => {
  return useQuery({
    queryKey: api.notice.getPolicyKey(params),
    queryFn: () => api.notice.getPolicy(params),
    select: (data) => data.data.result,
  });
};
